module.exports = __webpack_public_path__ + "static/13-8c0c812ea08ca4c78c197743ad31eeb0.jpg";